const ThankYouPage = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Thank You!</h2>
      <p>Your reference questionnaire has been successfully submitted.</p>
      <p>We appreciate your time and effort in completing this form.</p>
    </div>
  );
};

export default ThankYouPage;
